<template>
  <div class="Unprocessed_wrapper" :class="{ 'filter-loading': filterLoading }">
    <van-nav-bar title="未处理订单" @click-left="$utils.goBack()">
      <template #left>
        <span class="icon-left"></span>
      </template>
    </van-nav-bar>

    <div class="order_box" ref="orderList">
      <!-- 信息列表 -->
      <div class="order_list">
        <div class="order_item">
          <div class="item_label">车场名称</div>
          <div class="item_content">{{ orderObj.parkingName }}</div>
        </div>
        <div class="order_item">
          <div class="item_label">岗位名称</div>
          <div class="item_content">{{ orderObj.stationName }}</div>
        </div>
        <div class="order_item">
          <div class="item_label">车位号</div>
          <div class="item_content">{{ orderObj.parkingName }}</div>
        </div>
        <div class="order_item">
          <div class="item_label">入场时间</div>
          <div class="item_content">
            {{ orderObj.enterTime | dateFilter_yy_MM_dd_hh_mm_ss }}
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">出场时间</div>
          <div class="item_content">
            {{ orderObj.leaveTime | dateFilter_yy_MM_dd_hh_mm_ss }}
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">停车时长</div>
          <div class="item_content">
            {{ orderObj.stayTime | timeTransformation }}
          </div>
        </div>
        <div class="order_item">
          <div class="item_label">订单编号</div>
          <div class="item_content">{{ orderObj.id }}</div>
        </div>
        <div class="order_item">
          <div class="item_label">订单金额</div>
          <div class="item_content">{{ orderObj.orderAmount }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ORDER_PARKING_FIND_UNHANDLE_ORDER_PARKING_BY_ID } from "../../config/config";
export default {
  data: () => ({
    orderObj: {},
    filterLoading: false
  }),
  created() {
    this.$utils.changeStatusBarStyle("black");
    this.$utils.showLoading();

    let { orderunHandleId } = this.$route.params;

    this.$request(
      ORDER_PARKING_FIND_UNHANDLE_ORDER_PARKING_BY_ID,
      { orderunHandleId },
      res => {
        this.$utils.closeLoading();

        if (this.$condition.isRequestSuccess(res)) {
          this.orderObj = res["data"];
        }
      }
    );
  }
};
</script>

<style lang="less" scoped>
.Unprocessed_wrapper {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
  overflow: hidden;
  padding-top: 26px;
  display: flex;
  flex-direction: column;

  .icon-left {
    font-size: 24px;
    margin-right: 6px;
    color: #333;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}

.order_box {
  width: 100%;
  // height: calc(100% - 46px);
  padding: 0 18px;
  overflow: scroll;
  flex: 1;

  .order_list {
    width: 100%;
  }
}

.order_item {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  font-size: 20px;
  border-bottom: 1px solid rgba(7, 17, 27, 0.1);

  .item_label {
    flex: 0 0 100px;
    color: #000;
  }

  .item_content {
    flex: 1;
    color: #333;
    position: relative;

    .parkingNumberPop {
      position: absolute;
      left: 0;
      top: -10px;
      z-index: 51;
      background-color: #fff;
      padding: 8px 16px;
      font-size: 24px;
      border: 1px solid rgba(7, 17, 27, 0.1);
    }
  }

  .item_icon {
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 28px;
  }

  .item_btn {
    font-size: 20px;
    padding: 6px 18px;
    border-radius: 4px;
    background-color: #ccc;

    &.disabled {
      pointer-events: none;
    }
  }

  .order_item_btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
